// handle Remaps from older service
export function remap() {
	// rebuild to allow for 1 search param to have multiple values (doesn't conform the the spec.)
	const params = new URL(window.location.href).search
		.replace(/^\?/, "")
		.split("&")
		.reduce((acc, param) => {
			const [key, value] = param.split("=");
			const keyName = decodeURIComponent(key);
			if (acc.has(keyName)) {
				acc.get(keyName)?.push(value);
			} else {
				acc.set(keyName, [value]);
			}
			return acc;
		}, new Map<string, string[]>());

	if (params.size === 0) return;

	let found = false;

	// remap old school
	const schools = params.get("f.School|school");
	const subjects = params.get("f.Subject|subject");
	const audience = params.get("f.Audience|audience");

	if (schools) {
		params.set("schools", schools);
		params.delete("f.School|school");
		found = true;
	}

	// remap old audience
	if (audience) {
		params.set("audience", audience);
		params.delete("f.Audience|audience");
		found = true;
	}

	// Remap old subject
	if (subjects) {
		params.set("subjects", subjects);
		params.delete("f.Subject|subject");
		found = true;
	}

	const remappedParams = Array.from(params.entries())
		.map(([key, values]) => `${key}=${values.join("|")}`)
		.join("&");

	if (found) window.history.replaceState({}, "", `?${remappedParams}`);
}
